import React from "react";
import {toast} from "react-toastify";
import "./Toast.scss";
import "./ErrorToast.scss";
import {ToastBody} from "./ToastBody";
import {type ToastHandler} from "./types";

export const showErrorToast: ToastHandler = ({id, title = "Error!", message, link, when}) =>
  toast.error(<ToastBody title={title} message={message} link={link} when={when} />, {
    closeButton: false,
    icon: false,
    toastId: id
  });
